import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import toast from "react-hot-toast"

import { getQuestion } from "../../../api/question"
import { TQuestion } from "../../../api/type"

export const useQuestionDetail = (id: string | undefined) => {
  const navigate = useNavigate()
  const [question, setQuestion] = useState<TQuestion | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!id) {
      navigate("/questions")
      return
    }

    setLoading(true)
    getQuestion(id)
      .then((response) => {
        setQuestion(response?.data?.data ?? null)
      })
      .catch((error) => {
        console.error(error)
        toast.error("Failed to load question.")
        navigate("/questions")
      })
      .finally(() => {
        setLoading(false)
      })
  }, [id, navigate])

  const patchQuestion = (patch: Partial<TQuestion>) => {
    setQuestion((prev) => (prev ? { ...prev, ...patch } : prev))
  }

  return {
    question,
    loading,
    patchQuestion,
  }
}
